import { useState } from "react";
import { clsx } from "clsx";
import { ExternalLink, ChevronDown, ChevronUp } from "lucide-react";

// Ilham listesinin AI'a giden fotograflari — calismayi/tasarimi karsilastirmak icin
// adimin ustunde sabit durur. Kucuk resme tiklayinca buyuk resim degisir.
export function InspirationPanel({ images, url, title }: { images: string[]; url?: string | null; title?: string }) {
  const [active, setActive] = useState(0);
  const [open, setOpen] = useState(true);
  if (!images.length) return null;
  const main = images[Math.min(active, images.length - 1)];
  return (
    <div className="mb-5 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <div className="flex items-center justify-between gap-2">
        <button onClick={() => setOpen((o) => !o)} aria-expanded={open}
          className="inline-flex items-center gap-1 text-sm font-semibold text-gray-700">
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />} İlham listesi
          <span className="font-normal text-gray-500">({images.length} fotoğraf AI'a gönderildi)</span>
        </button>
        {url && (
          <a href={url.split("#")[0]} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 hover:underline">
            Etsy'de aç <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </div>
      {open && (
        <div className="mt-3 flex flex-col gap-3 sm:flex-row">
          <a href={main} target="_blank" rel="noopener noreferrer" title="Tam boyutta aç" className="flex-shrink-0">
            <img src={main} alt={title ?? "İlham fotoğrafı"} className="max-h-80 w-auto max-w-full rounded-lg border border-gray-200 bg-white object-contain" />
          </a>
          {images.length > 1 && (
            <div className="flex flex-wrap content-start gap-2">
              {images.map((u, i) => (
                <button key={u} onClick={() => setActive(i)} aria-pressed={i === active} title={i === 0 ? "Ana fotoğraf" : `Fotoğraf ${i + 1}`}
                  className={clsx("h-16 w-16 overflow-hidden rounded-lg border-2 bg-white", i === active ? "border-indigo-500" : "border-transparent hover:border-gray-300")}>
                  <img src={u} alt="" loading="lazy" className="h-full w-full object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
